var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReservation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.931641V2.93164H13V0.931641H15V2.93164H19C19.2652 2.93164 19.5196 3.037 19.7071 3.22453C19.8946 3.41207 20 3.66642 20 3.93164V19.9316C20 20.1969 19.8946 20.4512 19.7071 20.6387C19.5196 20.8263 19.2652 20.9316 19 20.9316H1C0.734784 20.9316 0.48043 20.8263 0.292893 20.6387C0.105357 20.4512 0 20.1969 0 19.9316V3.93164C0 3.66642 0.105357 3.41207 0.292893 3.22453C0.48043 3.037 0.734784 2.93164 1 2.93164H5V0.931641H7ZM18 7.93164H2V18.9316H18V7.93164ZM13.036 10.0676L14.45 11.4816L9.5 16.4316L5.964 12.8956L7.38 11.4816L9.501 13.6036L13.037 10.0676H13.036Z",
    fill: "#848FAC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReservation);
export default __webpack_public_path__ + "static/media/Reservation.6e4c308346ad7853489c8e9bcd3a8ab0.svg";
export { ForwardRef as ReactComponent };